import styles from './FaqItem.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'

const FaqItem = props => {

   const [isOpen, setIsOpen] = useState(false)

   const openClasses = isOpen ? styles.open : ''

   return <div className={styles.item} data-aos={props.animated} data-aos-duration="400" data-aos-delay={props.delay}>
      <div className={styles.item__head} onClick={() => setIsOpen(!isOpen)}>
         <FontAwesomeIcon className={styles.item__icon + ' ' + openClasses} icon={faAngleDown} />
         <h4 className={styles.item__title}>{props.title}</h4>
      </div>
      <div className={styles.item__body + ' ' + openClasses}>
         <div className={styles.item__content}>
            {props.body}
         </div>
      </div>
   </div>
}

export default FaqItem